type TokenRefresher = () => Promise<string>;

let refresher: TokenRefresher | null = null;
let refreshPromise: Promise<string> | null = null;

export const setTokenRefresher = (fn: TokenRefresher) => {
  refresher = fn;
};

export const refreshAccessToken = async (): Promise<string | null> => {
  if (!refresher) return null;

  // Deduplicate concurrent refresh attempts
  if (refreshPromise) return refreshPromise;

  try {
    refreshPromise = refresher();
    const token = await refreshPromise;
    localStorage.setItem("accessToken", token);
    return token;
  } catch {
    return null;
  } finally {
    refreshPromise = null;
  }
};
